import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import {AllowedPageSizes} from '../../../../../const/constants';
const TransactionStagingAssignTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
     
    const gridKey = "745FD8FE-1976-4AA2-A5F2-1A86A3A06507";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <Scrolling mode="virtual" />
                <Column dataField="customerIdentityId" caption="Customer" />
                <Column dataField="customerName" caption="Customer Name" />
                <Column dataField="warehouseId" caption="Staging WH" />
                <Column dataField="locationCode" caption="Staging Area" />
                <Column dataField="plannedReceivedShippedDateTime" dataType="date" format="MM/dd/yyyy" caption="Staging Planned Date" />
                <Column dataField="stagingStartDate" dataType="date" format="MM/dd/yyyy" caption="Staging Start Date" />
                <Column dataField="actualReceivedShippedDateTime" dataType="date" format="MM/dd/yyyy" caption="Received/Shipped Date" />
                <Column dataField="unloadPickBy" caption="Unload By" />
                <Column dataField="unloadPickByPlanDate" dataType="date" format="MM/dd/yyyy" caption="Unload Plan Date" />
                <Column dataField="checkBy" caption="Check By" />
                <Column dataField="checkByPlanDate" dataType="date" format="MM/dd/yyyy" caption="Check Plan Date" />
                <Column dataField="putAwayBy" caption="Put Away By" />
                <Column dataField="putAwayByPlanDate" dataType="date" format="MM/dd/yyyy" caption="Put Away Plan Date" />
                <Column dataField="comment" caption="Comment" />
                <Column dataField="department" caption="Department" />
                <Column dataField="departmentDescription" caption="Department Description" />
                <Column dataField="job" caption="Job" />
                <Column dataField="jobDescription" caption="Job Description" />
                <Column dataField="fund" caption="Fund" />
                <Column dataField="fundDescription" caption="Fund Description" />
                <Column dataField="recordNumber" caption="Record #" dataType="string" visible={false}></Column>
                <Column dataField="creationDateTime" caption="Creation Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="creationUserId" caption="Created By" dataType="string" visible={false}></Column>
                <Column dataField="lastUpdateDateTime" caption="Last Updated" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="lastUpdateUserId" caption="Last Updated By" dataType="string" visible={false}></Column>
                <Column dataField="dockYardWh" caption="DockYardWH" dataType="string" visible={false}></Column>
                <Column dataField="dockYardWhname" caption="DockYardWHName" dataType="string" visible={false}></Column>
                <Column dataField="stagingEndDate" caption="Staging Finish Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="fmtruckReference" caption="FM Truck Reference" dataType="string" visible={false}></Column>
                <Column dataField="fmdriverReference" caption="FM Driver Reference" dataType="string" visible={false}></Column>
                <Column dataField="fmtrailerReference" caption="FM Trailer Reference" dataType="string" visible={false}></Column>
                <Column dataField="truckReference" caption="Tansport Reference #" dataType="string" visible={false}></Column>
                <Column dataField="container" caption="Container #" dataType="string" visible={false}></Column>
                <Column dataField="equipmentInterchangeReport" caption="Trailer #/EIR" dataType="string" visible={false}></Column>
                <Column dataField="deliveryPickupDepartDateTime" caption="Dock Yard Arrive Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="truckArrivalDateTime" caption="Dock Yard Start Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="truckDepartDateTime" caption="Dock Yard End Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="transportationYardLeaveDate" caption="Dock Yard Leave Date" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="deliveryPickupPlannedDateTime" caption="Plan Apntmnt Date From" dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="deliveryPickupArrivedDateTime" caption="Plan Apntmnt Date To"dataType="datetime" format="MM/dd/yyyy hh:mm:ss a" visible={false}></Column>
                <Column dataField="transportDriverId" caption="Transport Driver" dataType="string" visible={false}></Column>
                <Column dataField="transportDriverName" caption="Transport Driver Name" dataType="string" visible={false}></Column>
                <Column dataField="transportTrailerId" caption="Transport Trailer" dataType="string" visible={false}></Column>
                <Column dataField="transportTruckId" caption="Transport Truck" dataType="string" visible={false}></Column>
                <Column dataField="loadBy" caption="Load By" dataType="string" visible={false}></Column>
                <Column dataField="pickBy" caption="Pick By" dataType="string" visible={false}></Column>
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(TransactionStagingAssignTab);